import { GetServerSidePropsContext } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import {
  getAgencyIdFromRequest,
  getLanguageFromRequest,
  getTranslation,
} from "../utils";
import sdk from "../sdk";
import DynamicPage from "../components/dynamic-page";
import { useAgency } from "../hooks/use-agency";
import Head from "next/head";
import { useTranslation } from "next-i18next";
import { track } from "../tracking";

export async function getServerSideProps({
  req,
  params,
  resolvedUrl,
}: GetServerSidePropsContext) {
  const locale = getLanguageFromRequest(req);
  const agencyId = getAgencyIdFromRequest(req);

  if (!params?.slug) {
    return {
      notFound: true,
    };
  }

  try {
    const section = await sdk.website.renderSection({
      agency_id: agencyId,
      section_slug:
        params.slug instanceof Array ? params.slug.join("/") : params.slug,
    });

    track(req, resolvedUrl, section.id);

    return {
      props: {
        ...(await serverSideTranslations(locale, ["common"])),
        agencyId,
        section,
      },
    };
  } catch (e: any) {
    if (e.isAxiosError && e.response.status === 404) {
      return {
        notFound: true,
      };
    }
    throw e;
  }
}

export default function Page({ section }: any) {
  const { i18n } = useTranslation();
  const agency = useAgency();

  const title = getTranslation(
    i18n.language,
    section.config.title as Record<string, string>
  );

  const description = getTranslation(
    i18n.language,
    section.config.description as Record<string, string>
  );

  const pageTitle = title ? `${title} - ${agency.name}` : agency.name;

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        {description && <meta name="description" content={description} />}
      </Head>
      <DynamicPage components={section.config.components ?? []} />
    </>
  );
}
